<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('user.koc.type')" >
        <a-select v-model="form.type" :placeholder="$t('system.selectPlaceholder')">
          <a-select-option :value="0">{{ $t('user.koc.goldCard') }}</a-select-option>
          <a-select-option :value="1">{{ $t('user.koc.vipCard') }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="numberValueLabel" prop="numberValue">
        <a-input-number v-model="form.numberValue" :min="0" :step="1" style="width: 100%;" :placeholder="$t('system.inputPlaceholder')" />
      </a-form-model-item>
      <a-form-model-item v-if="isAdd" :label="$t('user.koc.addAmount')" prop="targetCount">
        <a-input-number v-model="form.targetCount" :min="1" :step="1" style="width: 100%;" :placeholder="$t('system.inputPlaceholder')" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('common.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('common.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getKoc, addKoc, updateKoc } from '@/api/user/koc'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      type: 0,
      // 表单参数
      form: {
        id: null,

        userId: null,

        kocCode: null,

        useFlag: null,

        type: null,

        numberValue: null,

        targetCount: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    isAdd () {
      return this.formType === 1
    },
    numberValueLabel () {
      return Number(this.form.type) === 1
        ? this.$t('user.koc.vipDays')
        : this.$t('user.koc.goldAmount')
    },
    rules () {
      return {
        userId: [
          { required: true, message: this.$t('user.koc.userIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        kocCode: null,
        useFlag: null,
        type: null,
        numberValue: null,
        targetCount: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.form.type = 0
      this.form.targetCount = 1
      this.open = true
      this.formTitle = this.$t('common.add')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      this.type=1
      const id = row ? row.id : ids
      getKoc({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('common.edit')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateKoc(this.form).then(response => {
              this.$message.success(
                this.$t('common.updateSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addKoc(this.form).then(response => {
              this.$message.success(
                this.$t('common.addSuccess'),
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
